import { Component, OnInit, OnDestroy, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { SearchService } from '../../../search/search.service';
import { SearchEvent } from '../../../search/models/search-event';
import { NEW_SEARCH_EVENT, NEW_ROW_EVENT, PAGE_OVERFLOW_EVENT } from '../../../search/search-constants';
import { ResourceService } from 'sce-core';
import { UserService } from '../../../../core/security/user.service';
import { NavigationService } from '../../../../core/navigation.service';
import { AlertService } from 'sce-core';
import { ConfirmDialogService } from 'sce-core';
import { DetailViewKeyEventHandlerService } from '../../../services/detail-view-key-event-handler.service';
import { SearchableEntityConfig } from '../../../models/searchable-entity-config';
import { SearchableEntityServiceFactory } from '../../../services/searchable-entity/searchable-entity-service-factory';
import { ActivatedRoute } from '@angular/router';
import { LeftPanelService } from '../../../../layout/home/services/left-panel.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { DetailedEntityDataService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { DetailedEntityButtonService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { DetailedEntityDataEditorService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { UserPreferenceService } from '../../../../layout/home/services/user-preference.service';
import { TablePreference } from '../../../search/models/table-preference.model';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { FormPageConfig } from '../../../models/form-page-config';
import { UserPreferenceEvent, DELETE_FAVOURITE, ADD_FAVOURITE } from '../../../models/user-favourite-event';

@Component({
  selector: 'lfwms-searchable-entity-static-form',
  templateUrl: './static-form-page.component.html',
  styleUrls: ['./static-form-page.component.css']
})
export class SearchableEntityStaticFormComponent implements OnInit, OnDestroy {

  @Input() public serviceFactory: SearchableEntityServiceFactory;

  // Generic services
  protected dataService: DetailedEntityDataService;
  protected buttonService: DetailedEntityButtonService;
  protected dataEditor: DetailedEntityDataEditorService;

  // Service to maintain Master Data for Primary & Secondary Accordions in the Details Page
  protected primarySearchService: SearchService;
  // Search Service which is passed as input to Data Table inside Details Accordion
  protected detailsSearchService: SearchService;

  // the column group user preference
  public columnGroupUserPreference: any;

  /* Map Object <K,V> to maintain Cell Metadata [ for Primary & Secondary Accordions ] in the Details Page.
     This metadata is readily available from the Data Service and hence no fresh fetch is required. */
  public metadataMap: any;
  /* Map Object <K,V> to maintain Cell Data [ for Primary & Secondary Accordions ] in the Details Page.
     A fresh fetch is fired each time against a Receipt Key (dataService.primarySelectedDocument) from ngOnInit() */
  public cellDataMap: any;

  private keyEventHandler: DetailViewKeyEventHandlerService;

  // public isLoading: boolean = false;

  // public isPrimaryDataLoaded: boolean = false;

  // variable to store all object level sunscriptions. This will be unsubscribed on component destroy
  private subscriptionLists: Array<Subscription>;
  // Flag to show/hide Details Accordion
  // public showDetailsSection: boolean = false;
  // Flag to expand/collapse Details Accordion
  public expandDetailsSection: boolean = true;

  public entityConfig: SearchableEntityConfig;
  public showBreadcrumbLabel = false;
  public selectedValue: String;
  public tooltipPosition: string = 'bottom';
  public tooltipMessage: string = 'Add to Favourites';

  private favouritePreference: any;

  // public primaryAccordion: AccordionConfig;
  // public secondaryAccordionList: Array<AccordionConfig>;
  // flag indicating if the state should be retained
  private retainState: boolean;
  // variables for smooth scrolling of floating menu
  private floatingMenuOffset;
  public isStickyFloatingMenu: boolean;
  private previousScroll = 0;
  private isScrollDown = false;

  protected navService: NavigationService;
  protected resourceService: ResourceService;
  protected userService: UserService;
  // private activatedRoute: ActivatedRoute;
  protected alertService: AlertService;
  protected confirmDialogService: ConfirmDialogService;
  protected userPreferenceService: UserPreferenceService;
  public tablePreference: TablePreference;
  public favouriteIconFlag: boolean = true;
  protected userPreferenceEventSubscription: Subscription;

  public pageConfig: FormPageConfig;

  public columnGroupWidgetList: Array<LFDynamicWidgetConfig>;

  @ViewChild('floatingMenuId', { read: ElementRef }) navbarif: ElementRef;
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.floatingMenuOffset = this.navbarif.nativeElement.offsetTop;
    if (this.previousScroll < window.pageYOffset) {
      this.isScrollDown = true;
    } else {
      this.isScrollDown = false;
    }
    this.previousScroll = window.pageYOffset;
    // floating menu is getting fixed when height is 40 px from top, that is why we are adding/subtracting 39 px
    // to the offset. So that there wont be any sudden jumps during scrolling.
    if ((window.pageYOffset + (this.isScrollDown ? 39 : -39)) >= (this.floatingMenuOffset)) {
      this.isStickyFloatingMenu = true;
    } else {
      this.isStickyFloatingMenu = false;
    }
  }

  constructor(private coreServiceRegistry: CoreServiceRegistry, private sharedServiceRegistry: SharedServiceRegistry,
    public leftPanelService: LeftPanelService, private activatedRoute: ActivatedRoute) {
    this.navService = coreServiceRegistry.navigationService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.userService = coreServiceRegistry.userService;
    this.alertService = sharedServiceRegistry.alertService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
    this.userPreferenceService = sharedServiceRegistry.userPreferencesService;
    //  this.activatedRoute = coreServiceRegistry.activatedRoute;

    // Initializing Cell Data Map
    this.cellDataMap = {};
    this.subscriptionLists = [];
  }


  /**
   * Initializes the component
   */
  public ngOnInit() {
    this.initializeProperties();
    this.initializeTablePreferences();
    this.subscribeForEvents();
    const detailPagePresent = this.dataService.getEntityConfiguration().getDetailPageRoute();
    this.pageConfig.isPageLoaded = false;
    //   this.activatedRoute.params.subscribe(params => {
    //     this.navService.setPageTitle(this.entityConfig.getItemLabel().concat(' ').concat(this.resourceService.get('lbl_search')));
    // });
    if (detailPagePresent) {
      this.navService.setPageTitle(this.entityConfig.getItemLabel()
        .concat(' ').concat(this.resourceService.get('lbl_search')));
    } else {
      this.navService.setPageTitle(this.entityConfig.getItemLabel());
    }
    // Initialize the page once the metadata is available
    this.primarySearchService.fetchMetadata().subscribe(metadata => {
      this.initializePrimaryMetadataMap(metadata);
      this.cellDataMap = this.dataService.createNewRecord();
      this.initializePage();
      this.pageConfig.isPageLoaded = true;
    });
  }

  /**
   * Initializes the component properties
   */
  private initializeProperties() {
    this.dataService = <DetailedEntityDataService>this.serviceFactory.getDataService();
    this.entityConfig = this.dataService.getEntityConfiguration();
    this.buttonService = <DetailedEntityButtonService>this.serviceFactory.getButtonService();
    this.dataEditor = <DetailedEntityDataEditorService>this.serviceFactory.getDataEditor();
    this.primarySearchService = this.dataService.getPrimarySearchService();
    if (this.entityConfig.formPageConfig.keyEventHandler) {
      this.keyEventHandler = this.entityConfig.formPageConfig.keyEventHandler;
    } else {
      this.keyEventHandler = new DetailViewKeyEventHandlerService(this.dataEditor);
    }

    this.pageConfig = this.dataService.entityConfig.formPageConfig;
    //    this.pageConfig.detailPageComponent = this;
    this.pageConfig.dataService = this.dataService;
    this.pageConfig.buttonService = this.buttonService;
    this.pageConfig.dataEditor = this.dataEditor;
    this.pageConfig.keyEventHandler = this.keyEventHandler;
    this.pageConfig.pageLabel = this.entityConfig.getItemLabel();
    this.pageConfig.showDetailsSection = this.entityConfig.getShowDetailLineItems();
  }

  // initializes the page.
  protected initializePage() {
    this.initializePrimarySection();
    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      this.initializeDetailTable();
    }
  }
  private initializeTablePreferences() {
    this.userPreferenceService
      .fetchTablePreferences(this.primarySearchService
        .searchParams.tableId, 'FAVOURITECONFIG')
      .subscribe((favouritePreference: any) => {
        this.favouritePreference = favouritePreference;
        this.favouriteIconFlag = this.favouritePreference.configuration.favourite;
      });
  }
  // loads the primary section which includes all accordian groups
  protected initializePrimarySection() {
    this.dataService.setPrimaryDataMap(this.cellDataMap);
    this.pageConfig.cellDataMap = this.cellDataMap;
    this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
    if (this.entityConfig.getBreadCrumbPrefix()) {
      this.navService.addNonNavigableBreadCrumb(this.entityConfig.getBreadCrumbPrefix());
    }
    this.pageConfig.isPrimarySectionLoaded = true;
  }

  private initializePrimaryMetadataMap(metadata) {
    this.metadataMap = {};
    const columnsByGroup = {};
    this.columnGroupUserPreference = {};
    const columnGroupWidgetList: Array<LFDynamicWidgetConfig> = [];

    // Metadata for Primary & Secondary Accordions are readily available in Primary Search Service
    metadata.columnList.map((column: any) => {
      // Metadata.columnList is iterated and categorized based on columnGroup
      if (!columnsByGroup[column.columnGroup]) {
        columnsByGroup[column.columnGroup] = [];
        if (column.columnGroup !== 'Primary' && column.columnGroup !== 'ACCORDION') {
          this.columnGroupUserPreference[column.columnGroup] = Object.keys(this.columnGroupUserPreference).length;
        }
      }
      columnsByGroup[column.columnGroup].push(column.propertyName);
      this.metadataMap[column.propertyName] = column;
    });
    this.tablePreference = this.primarySearchService.getTablePreference();
    this.pageConfig.userPreference = this.tablePreference;
    if (Object.keys(this.tablePreference.columGroupConfig.configuration).length === 0) {
      this.tablePreference.columGroupConfig.configuration = this.columnGroupUserPreference;
    } else {
      this.columnGroupUserPreference = this.tablePreference.columGroupConfig.configuration;
    }
    Object.keys(columnsByGroup).forEach((columnGroup: any) => {
      // if the column group name is ACCORDION, then do not show it
      if (columnGroup === 'ACCORDION') {
        return;
      }
      const columnGroupWidget = new LFDynamicWidgetConfig();
      columnGroupWidget.id = columnGroup;
      columnGroupWidget.columnGroup = columnGroup;
      columnGroupWidget.propertyList = columnsByGroup[columnGroup];
      columnGroupWidget.name = this.resourceService.get(columnGroup);
      columnGroupWidget.activeIndex = this.columnGroupUserPreference[columnGroup];
      //      columnGroupWidget.widgetType = (columnGroup === 'Primary') ? 'P' : 'S';
      columnGroupWidgetList.push(columnGroupWidget);
    });

    // this.customizeMetadataMap();
    this.dataService.primaryMetaDataMap = this.metadataMap;
    this.pageConfig.metaDataMap = this.metadataMap;
    this.dataService.primaryColumnGrouping = columnsByGroup;
    this.columnGroupWidgetList = columnGroupWidgetList;
    // the below code is added to override the metadata object
    this.dataService.overrideMetadataMap(this.dataService.displayMode);
  }

  // Method to Customize Metadata for Display Only Changes
  private customizeMetadataMap() {
    // Overriding Metadata for facility to display it in ['Key - Value'] format
    // Below, Deep Clone has to be performed to avoid directly updating Metadata Object in Service
    if (!this.metadataMap['facility']) {
      return;
    }
    const facilityMetadata = JSON.parse(JSON.stringify(this.metadataMap['facility']));
    facilityMetadata.values.forEach((option) => {
      option.value = option.key + ' - ' + option.value;
    });
    this.metadataMap['facility'] = facilityMetadata;
  }

  public getBreadCrumbText() {
    if (this.dataService.getPrimarySelectedDocument()) {
      this.selectedValue = this.entityConfig.getBreadCrumbPrefix() + this.dataService.getPrimarySelectedDocument();
      this.showBreadcrumbLabel = true;
      return true;
    }
  }

  // initializes the line item detail table
  public initializeDetailTable() {
    // if the retainState flag is set, do not reinitialize the service. Use the service already loaded in the memory
    if (!this.retainState || !this.dataService.getDetailsSearchService()) {
      this.dataService.initializeDetailsSearchContext();
    }
    this.detailsSearchService = this.dataService.getDetailsSearchService();
    //LFWM-3363 resetting the max line number for every new detail table
    this.dataService.maxIdValueForDetailTable='';    
    const metadataSubscription = this.detailsSearchService.fetchMetadata().subscribe((metadata) => {
      metadata.columnList.sort((a, b) => {
        return a.index - b.index;
      });
      this.pageConfig.isDetailSectionLoaded = true;
      // this.showDetailsSection = true;
      this.expandDetailsSection = true;
    });
    this.subscriptionLists.push(metadataSubscription);

    // Subscription for the Search Events from Details Search Service.
    const detailsSearchEventSubscription = this.detailsSearchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
        if (event.type === NEW_SEARCH_EVENT && this.detailsSearchService.getMetadata()) {
          // For NEW_SEARCH_EVENT, the Details Data Table will be displayed
          this.pageConfig.isDetailSectionLoaded = true;
        } else if (event.type === NEW_ROW_EVENT) {
          // For NEW_ROW_EVENT
          this.dataService.handleAddNewLineItem(event);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.detailsSearchService.setNewPageEventInProgress(true);
          this.buttonService.performButtonActions('Save');
        }
      });
    this.subscriptionLists.push(detailsSearchEventSubscription);
  }

  private subscribeForEvents() {
    this.userPreferenceEventSubscription = this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          // if the user is on the same page as that of the table to be removed from favourites list from side panel
          // Fix for LFWM 1213
          if (event.preferenceId === this.tablePreference.favouriteConfig.preferenceId) {
            this.favouriteIconFlag = false;
          }
          // this.userPreferences.preferenceId = null;
        } else if (event.type === ADD_FAVOURITE) {
          this.favouriteIconFlag = true;
        }
      });
  }
  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  // Method to return Cell Title corresponding to each property
  public getCellTitle(property: any): string {
    return this.resourceService.get(this.metadataMap[property].elementId);
  }

  // Method  to override default display format for each cell value (in VIEW Mode ONLY)
  public getCellDisplayValue(property: any): any {
    return ''; // this.dataService.getCellDisplayValue(property, this.isLoading);
  }

  private openLookup(cells: any, property: any) {
    const row = { cells: this.cellDataMap };
    this.dataEditor.openLookup(row, property);
  }

  // method to handle cell change
  public handleCellChange(event: any) {
    if (event.eventType === 'CELL_VALUE_CHANGED' && event.value) {
      /* Adding the below code as the user should not be permitted to change the header status to 'Finalized'
          and save the adjustment ticket, user should only finalize the adjustment using Finalize adjustment action*/
      if (event.value.cName === 'finalizedflag' && event.value.cVal === 'Y') {
        this.alertService.clearAll().error('err_chg_fin_adj');
        return;
      }
      if (event.value.cName === 'finalizedflag' && (event.value.cVal === 'A' || event.value.cVal === 'R')) {
        const adjustmentKey = this.dataService.getPrimaryDataIdValue();
        this.dataEditor.updateDetailStatus(adjustmentKey);
      }
    }
  }
  // add/remove favorite config
  public toggleFavourites() {
    // if the page is set as favourite
    if (this.favouriteIconFlag === false) {
      const userPreferences = {
        dataTableId: this.primarySearchService.searchParams.tableId,
        prefType: 'FAVOURITECONFIG',
        configuration: { 'favourite': true }
      };
      this.userPreferenceService.saveTablePreferences(userPreferences).subscribe((data: any) => {
        this.favouriteIconFlag = true;
        this.tablePreference.favouriteConfig = data;
        //   this.userPreferences.preferenceId = data['preferenceId'];
        this.notifyUserPreferenceEvent(ADD_FAVOURITE);
        this.alertService.success(this.resourceService.get('msg_fav_add'));
      }, (error: any) => {
        this.alertService.clearAll().error(this.resourceService.get(error.error.errors['0'].validationMessage));
      });
    } else {
      this.userPreferenceService.deleteFavorites(this.tablePreference.favouriteConfig.preferenceId).subscribe((data: any) => {
        this.favouriteIconFlag = false;
        this.tablePreference.favouriteConfig = null;
        this.alertService.success(this.resourceService.get('msg_fav_del'));
        this.notifyUserPreferenceEvent(DELETE_FAVOURITE);
      });
    }
  }

  private notifyUserPreferenceEvent(type: number, isExternal?: boolean) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.source = 'search';
    event.preferenceId = type;
    if (isExternal) {
      event.isExternal = isExternal;
    }
    this.userPreferenceService.notifyEvent(event);
  }

  public ngOnDestroy() {
    if (this.subscriptionLists) {
      this.subscriptionLists.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
    if (this.userPreferenceEventSubscription) {
      this.userPreferenceEventSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/searchable-entity/static-form-page/static-form-page.component.ts